import { defineMessages } from 'react-intl';

const messages = defineMessages({
  exerciseArchived: {
    id: 'hooks.exercises.useDeleteExerciseById.exerciseArchived',
    defaultMessage: 'Exercise archived successfully!',
  },
  exerciseCreated: {
    id: 'hooks.exercises.useDeleteExerciseById.exerciseCreated',
    defaultMessage: 'Exercise {name} created successfully!',
  },
  exerciseEdited: {
    id: 'hooks.exercises.useDeleteExerciseById.exerciseEdited',
    defaultMessage: 'Exercise {name} edited successfully!',
  },
  exercisePostedToMarketplace: {
    id: 'hooks.exercises.usePostExerciseToMarketplace.posted',
    defaultMessage: 'Exercise posted to marketplace successfully!',
  },
  exerciseRemovedFromMarketplace: {
    id: 'hooks.exercises.usePostExerciseToMarketplace.removed',
    defaultMessage: 'Exercise removed from marketplace successfully!',
  },
  exerciseUnarchived: {
    id: 'hooks.exercises.useDeleteExerciseById.exerciseUnarchived',
    defaultMessage: 'Exercise unarchived successfully!',
  },
});

export default messages;
